import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)

import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchCheckbox',
  emits: ["switched"],
  setup(__props, { emit: emits }) {



const state = reactive({
  checked: false,
});

function handle_click() {
  emits("switched", state.checked);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.checked) = $event)),
      onClick: handle_click
    }, null, 512), [
      [_vModelCheckbox, state.checked]
    ]),
    _hoisted_2
  ]))
}
}

})